import { gql } from '@apollo/client';

export const GET_ADMINTRANSACTION_DETAILS = gql`
mutation adminTransactionLookup($transactionid : String!) {
  adminTransactionLookup(transactionid: $transactionid) {
    status
    error
    customer{
      firstname
      lastname
      address1
      address2
      city
      state
      zip
      phone
      email
      country
      gender
      customerid
      datetimecreated
      datetimeupdated
      birthdate
      isEnabled
      plaidverified
      creditCardsCount
      transactionsCount
      totalTransactedAmount
      notes
    }
    transaction{
      ctransid
      gateway
      referenceid1
      datetimecreated
      price
      datetimeupdated
      datetimeexpire
      datetimeactivated
      datetimedisabled
      enabled
      activated
      invoicenumber
      shortdescription
      storageusername
      activationcode
      disputed
      disputevalid
      disputeinitiatedby
      disputestatus
      disputereason
      disputenotes
      datetimedisputed
      manual_override
      customer_ip
      override_ip
    }
  }
}
`;

export const RESEND_TRANSACTION_RECEIPT = gql`
mutation adminResendTransactionReceipt($transactionid : String!) {
  adminResendTransactionReceipt(transactionid: $transactionid) {
    status
    error
  }
}
`;

export const UPDATE_DISPUTE_VALID_BY_CTRANSACTION_ID = gql`
mutation adminUpdateDisputeValidByCTransactionId ($ctransid: String!, $disputevalid: Boolean!) {
  adminUpdateDisputeValidByCTransactionId (ctransid: $ctransid, disputevalid: $disputevalid) {
    status
    error
    data
  }
}`;

export const UPDATE_DISPUTE_STATUS_BY_CTRANSACTION_ID = gql`
mutation adminUpdateDisputeStatusByCTransactionId ($ctransid: String!, $disputestatus: String!) {
  adminUpdateDisputeStatusByCTransactionId (ctransid: $ctransid, disputestatus: $disputestatus) {
    status
    error
    data
  }
}`;

export const UPDATE_DISPUTE_NOTES_BY_CTRANSACTION_ID = gql`
mutation adminUpdateDisputeNotesByCTransactionId ($ctransid: String!, $disputenotes: String!) {
  adminUpdateDisputeNotesByCTransactionId (ctransid: $ctransid, disputenotes: $disputenotes) {
    status
    error
    data
  }
}`;

export const DISPUTE_TRANSACTION_BY_CTRANSACTION_ID = gql`
mutation adminDisputeTransactionByCTransactionId(
  $ctransid: String!,
  $disputevalid: Boolean!,
  $disputestatus: String!,
  $disputereason: String!,
  $disputenotes: String,
  $datetimedisputed: String,
) {
  adminDisputeTransactionByCTransactionId(
    ctransid: $ctransid,
    disputevalid: $disputevalid,
    disputestatus: $disputestatus,
    disputereason: $disputereason,
    disputenotes: $disputenotes,
    datetimedisputed: $datetimedisputed,
  ) {
    status
    error
    transaction{
      ctransid
      gateway
      datetimecreated
      price
      disputed
      disputevalid
      disputeinitiatedby
      disputestatus
      disputereason
      disputenotes
      datetimedisputed
      manual_override
    }
  }
}`;

export const GET_ALL_DISPUTED_TRANSACTIONS_BY_CUSTOMER_ID = gql`
query adminGetAllDisputedTransactionsByCustomerId($customerid: String!) {
  adminGetAllDisputedTransactionsByCustomerId(customerid: $customerid) {
    status
    error
    transactions {
      ctransid
      gateway
      datetimecreated
      price
      disputed
      disputeinitiatedby
      disputevalid
      disputestatus
      disputereason
      disputenotes
      datetimedisputed
      manual_override
    }
  }
}`;

export const GET_ALL_DISPUTED_TRANSACTIONS = gql`
query adminGetAllDisputedTransactions(
  $limit: Float,
  $gateway: String,
) {
  adminGetAllDisputedTransactions(
    limit: $limit
    gateway: $gateway
  ) {
    status
    error
    transactions {
      ctransid
      gateway
      datetimecreated
      price
      disputed
      disputeinitiatedby
      disputevalid
      disputestatus
      disputereason
      disputenotes
      datetimedisputed
      manual_override
    }
  }
}`;